module.exports = __webpack_public_path__ + "static/eb/img/x.e588d573.svg";